module.exports = __webpack_public_path__ + "img/1.acea104f.png";